export const OBSIDIAN_BLOCK_ID = 31;
export const QUARTZ_BLOCK_ID = 39;
export const NETHER_PORTAL_BLOCK_ID = 43;
export const END_PORTAL_BLOCK_ID = 46;
export const FIRE_BLOCK_ID = 64;

export const PORTAL_INNER_WIDTH = 2;
export const PORTAL_INNER_HEIGHT = 3;
export const NETHER_PORTAL_MAX_INNER_WIDTH = 21;
export const NETHER_PORTAL_MAX_INNER_HEIGHT = 21;
export const PORTAL_TRAVEL_CHARGE_SECONDS = 1.9;
export const PORTAL_COOLDOWN_SECONDS = 2.4;
export const NETHER_RATIO = 8;

export const DEATH_ANIMATION_SECONDS = 3.0;
